import { ReactElement, useEffect } from "react";
import { useDynamicPageMeta } from "../../../hooks/useDynamicPageMeta";
import "../../../assets/css/PageSurface.css";
import "../../../assets/css/Text.css";
import EmailSettings from "./components/EmailSettings";

export default function Settings(): ReactElement {
  const { setPageMeta, clearPageMeta } = useDynamicPageMeta();

  useEffect(() => {
    setPageMeta({
      title: "Settings",
      breadcrumbLabels: {
        "/admin": "Settings",
        "/admin/settings": "Settings",
      },
    });
    return () => {
      clearPageMeta();
    };
  }, [setPageMeta, clearPageMeta]);

  return (
    <div className="page-sheet">
      <h2>Settings</h2>
      <EmailSettings />
    </div>
  );
}
